import { useMemo } from 'react';

import { FlexAligner, ModalContent, ModalFooter, ModalHeader } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { getTemplateWidgets } from '@/components/layout/layoutBox/getTemplateWidgets.ts';
import { TemplateIcon } from '@/components/TemplateIcon.tsx';
import { useLayoutStorage } from '@/stores';
import { StyledModal } from '@/styles.ts';
import { ModalControllerType } from '@/types.ts';

type ShortcutsDialogProps = {
  modalController: ModalControllerType;
};

export const CurrentLayoutIndexModal = ({ modalController }: ShortcutsDialogProps) => {
  const { t } = useTranslation(['common']);

  const findStoredLayoutById = useLayoutStorage(s => s.findStoredLayoutById);
  const currentLayoutId = useLayoutStorage(s => s.currentLayoutId);
  const layoutWidgets = useMemo(() => {
    const currentLocalLayout = findStoredLayoutById(currentLayoutId);
    return currentLocalLayout ? getTemplateWidgets(currentLocalLayout) : undefined;
  }, [currentLayoutId, findStoredLayoutById]);

  return (
    <StyledModal
      closeOnBackdropClick
      closeOnEscapeClick
      open={modalController.open}
      onClose={modalController.onClose}
      $minHeight={'fit-content'}
      $width={'fit-content'}
    >
      <ModalHeader title={t('layoutIndexMap')} onClose={modalController.onClose} />
      <StyledModalContent>
        <FlexAligner
          alignment='center'
          fullWidth={false}
          style={{ height: '20rem', paddingLeft: '2rem' }}
        >
          {layoutWidgets && (
            <TemplateIcon style={{ cursor: 'default' }} widgets={layoutWidgets} withIndex />
          )}
        </FlexAligner>
      </StyledModalContent>
      <ModalFooter actionButtons={[{ label: t('close'), onClick: modalController.onClose }]} />
    </StyledModal>
  );
};

const StyledModalContent = styled(ModalContent)`
  padding-left: 0;
  padding-right: 0;
`;
